import React from 'react'

import { t } from '@/i18n'

import { useSearch } from '../SearchContext'

export type TModelFilter =
  | 'cars'
  | 'deals'
  | 'invoices'
  | 'reports'
  | 'proposals'
  | 'customers'

const models: {
  key: string
  value: TModelFilter
  icon: string
}[] = [
  {
    key: 'cars',
    value: 'cars',
    icon: 'icon-car',
  },
  {
    key: 'deals',
    value: 'deals',
    icon: 'icon-incandescent',
  },
  {
    key: 'invoices',
    value: 'invoices',
    icon: 'icon-file',
  },
  {
    key: 'reports',
    value: 'reports',
    icon: 'icon-reports',
  },
  {
    key: 'proposals',
    value: 'proposals',
    icon: 'icon-briefcase',
  },
  {
    key: 'customers',
    value: 'customers',
    icon: 'icon-customer',
  },
]

const ModelFilter: React.FC = () => {
  const { filter, onChangeFilter } = useSearch()

  return (
    <div className="search-filter">
      <div className="btn-item">
        <p>{t('filters')}</p>
      </div>
      <div className="drop-item">
        <ul>
          {models.map(model => (
            <li key={model.key}>
              <label>
                <input
                  readOnly
                  name="filter"
                  type="checkbox"
                  checked={filter.includes(model.value)}
                  onClick={() => onChangeFilter(model.value)}
                />
                <span className="">{t(model.key)}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ModelFilter
